<template>
  <div id="SectionRisk">
    <UIContainer>
      <SectionTitle class="SectionRisk__title">
        <template #title>
          Reduce risk. Reduce effort. Increase confidence.
        </template>
      </SectionTitle>

      <div class="SectionRisk__metrics">
        <div
          class="SectionRisk__metric"
          v-for="metric in metrics"
          :key="metric.percentage"
        >
          <div class="SectionRisk__metric-value">
            <span class="SectionRisk__metric-percentage">
              {{ metric.percentage }}
            </span>
            <UIIcon name="arrowDown" class="SectionRisk__metric-arrow" />
          </div>
          <p class="SectionRisk__metric-description">
            {{ metric.description }}
          </p>
        </div>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

const metrics = [
  {
    percentage: '-90%',
    description: 'Time spent on manual data collection & validation.',
  },
  {
    percentage: '-75%',
    description: 'Audit preparation and response time.',
  },
  {
    percentage: '-94%',
    description: 'Reduction in data errors and reporting restatements.',
  },
]
</script>

<style lang="scss" scoped>
#SectionRisk {
  .SectionRisk__title {
    text-align: center;
    margin: 0 auto 1rem;
    max-width: 48rem;
  }

  .SectionRisk__metrics {
    margin-top: 4rem;
    padding: 4rem;
    display: grid;
    gap: 2rem;
    background-color: $color-ui-gray-cool-50;
    border-radius: 1rem;
    grid-template-columns: 1fr;

    @include sm {
      gap: 2.5rem;
      padding: 3.5rem 2.5rem;
    }

    @include md {
      gap: 3rem;
      padding: 4rem 3rem;
      // Desktop: Three columns
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .SectionRisk__metric {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .SectionRisk__metric-value {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
    flex-direction: column;

    @include md {
      flex-direction: row;
    }
  }

  .SectionRisk__metric-percentage {
    @include font-size-36px;
    font-weight: 600;
    color: $color-ui-accent-main;

    @include md {
      font-size: 3rem;
      line-height: 3.5rem;
    }
    @include lg {
      @include font-size-60px();
    }
  }

  .SectionRisk__metric-arrow {
    --size: 3.25rem;
    --color: #{$color-ui-accent-main};
  }

  .SectionRisk__metric-description {
    @include font-size-14px();
    color: $color-ui-gray-cool-900;
    max-width: 21.25rem;
    font-weight: 600;

    @include md {
      @include font-size-18px();
    }
  }
}
</style>
